// src/modules/bkg/views/filterHydration.ts
//
// Helpers for persisting BKG filter state in the ?f= URL query param.

import type { FilterInterface } from "./SearchFilters";

export type FilterHydrationMap = Record<string, FilterInterface>;

export const flattenFilterDoc = (doc: any): FilterHydrationMap => {
  const map: FilterHydrationMap = {};
  const walk = (node: any) => {
    if (!node || typeof node !== "object" || typeof node.path !== "string") {
      return;
    }
    map[node.path] = node;
    if (Array.isArray(node.children)) {
      for (const child of node.children) walk(child);
    }
  };
  walk(doc);
  return map;
};

export const encodeFilterDoc = (doc: any): string => {
  if (!doc || (typeof doc === "object" && Object.keys(doc).length === 0)) {
    return "";
  }
  try {
    return btoa(encodeURIComponent(JSON.stringify(doc)));
  } catch {
    return "";
  }
};

export const decodeFilterDoc = (encoded: string | null | undefined): any => {
  if (!encoded) return null;
  try {
    return JSON.parse(decodeURIComponent(atob(encoded)));
  } catch {
    return null;
  }
};
